// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TenantPresentationConfiguration_TenantDisclaimerConfigurationFragment = { __typename?: 'TenantDisclaimerConfiguration', id: string, includeLuminaryDisclaimer: boolean, presentationCoverDisclaimerTitle?: string | null, presentationCoverDisclaimerBody?: string | null, presentationFooterDisclaimerTitle?: string | null, presentationFooterDisclaimerBody?: string | null, presentationStandaloneDisclaimerTitle?: string | null, presentationStandaloneDisclaimerBody?: string | null };

export type TenantPresentationConfiguration_HouseholdFragment = { __typename?: 'Household', id: string, subBrand?: (
    { __typename?: 'SubBrand' }
    & TenantPresentationConfiguration_SubBrandFragment
  ) | null };

export type TenantPresentationConfiguration_SubBrandFragment = { __typename?: 'SubBrand', id: string, disclaimerConfiguration?: (
    { __typename?: 'SubBrandDisclaimerConfiguration' }
    & TenantPresentationConfiguration_SubBrandDisclaimerConfigurationFragment
  ) | null };

export type TenantPresentationConfiguration_SubBrandDisclaimerConfigurationFragment = { __typename?: 'SubBrandDisclaimerConfiguration', id: string, includeLuminaryDisclaimer: boolean, presentationCoverDisclaimerTitle?: string | null, presentationCoverDisclaimerBody?: string | null, presentationFooterDisclaimerTitle?: string | null, presentationFooterDisclaimerBody?: string | null, presentationStandaloneDisclaimerTitle?: string | null, presentationStandaloneDisclaimerBody?: string | null };

export type TenantPresentationConfiguration_EffectiveDisclaimerConfigurationFragment = { __typename?: 'EffectiveDisclaimerConfiguration', includeLuminaryDisclaimer: boolean, presentationCoverDisclaimerTitle?: string | null, presentationCoverDisclaimerBody?: string | null, presentationFooterDisclaimerTitle?: string | null, presentationFooterDisclaimerBody?: string | null, presentationStandaloneDisclaimerTitle?: string | null, presentationStandaloneDisclaimerBody?: string | null };

export type EffectivePresentationDisclaimerConfigurationQueryVariables = Types.Exact<{
  subBrandID?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type EffectivePresentationDisclaimerConfigurationQuery = { __typename?: 'Query', effectiveDisclaimerConfiguration: (
    { __typename?: 'EffectiveDisclaimerConfiguration' }
    & TenantPresentationConfiguration_EffectiveDisclaimerConfigurationFragment
  ) };

export type TenantDisclaimerConfigurationQueryVariables = Types.Exact<{
  householdID?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  hasHouseholdID: Types.Scalars['Boolean']['input'];
}>;


export type TenantDisclaimerConfigurationQuery = { __typename?: 'Query', tenantInformation: { __typename?: 'TenantInformation', id: string, disclosuresConfiguration?: (
      { __typename?: 'TenantDisclaimerConfiguration' }
      & TenantPresentationConfiguration_TenantDisclaimerConfigurationFragment
    ) | null }, households?: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: (
        { __typename?: 'Household' }
        & TenantPresentationConfiguration_HouseholdFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    EffectivePresentationDisclaimerConfiguration: 'EffectivePresentationDisclaimerConfiguration' as const,
    TenantDisclaimerConfiguration: 'TenantDisclaimerConfiguration' as const
  },
  Fragment: {
    TenantPresentationConfiguration_TenantDisclaimerConfiguration: 'TenantPresentationConfiguration_TenantDisclaimerConfiguration' as const,
    TenantPresentationConfiguration_Household: 'TenantPresentationConfiguration_Household' as const,
    TenantPresentationConfiguration_SubBrand: 'TenantPresentationConfiguration_SubBrand' as const,
    TenantPresentationConfiguration_SubBrandDisclaimerConfiguration: 'TenantPresentationConfiguration_SubBrandDisclaimerConfiguration' as const,
    TenantPresentationConfiguration_EffectiveDisclaimerConfiguration: 'TenantPresentationConfiguration_EffectiveDisclaimerConfiguration' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const TenantPresentationConfiguration_TenantDisclaimerConfigurationFragmentDoc = gql`
    fragment TenantPresentationConfiguration_TenantDisclaimerConfiguration on TenantDisclaimerConfiguration {
  id
  includeLuminaryDisclaimer
  presentationCoverDisclaimerTitle
  presentationCoverDisclaimerBody
  presentationFooterDisclaimerTitle
  presentationFooterDisclaimerBody
  presentationStandaloneDisclaimerTitle
  presentationStandaloneDisclaimerBody
}
    `;
export const TenantPresentationConfiguration_SubBrandDisclaimerConfigurationFragmentDoc = gql`
    fragment TenantPresentationConfiguration_SubBrandDisclaimerConfiguration on SubBrandDisclaimerConfiguration {
  id
  includeLuminaryDisclaimer
  presentationCoverDisclaimerTitle
  presentationCoverDisclaimerBody
  presentationFooterDisclaimerTitle
  presentationFooterDisclaimerBody
  presentationStandaloneDisclaimerTitle
  presentationStandaloneDisclaimerBody
}
    `;
export const TenantPresentationConfiguration_SubBrandFragmentDoc = gql`
    fragment TenantPresentationConfiguration_SubBrand on SubBrand {
  id
  disclaimerConfiguration {
    ...TenantPresentationConfiguration_SubBrandDisclaimerConfiguration
  }
}
    ${TenantPresentationConfiguration_SubBrandDisclaimerConfigurationFragmentDoc}`;
export const TenantPresentationConfiguration_HouseholdFragmentDoc = gql`
    fragment TenantPresentationConfiguration_Household on Household {
  id
  subBrand {
    ...TenantPresentationConfiguration_SubBrand
  }
}
    ${TenantPresentationConfiguration_SubBrandFragmentDoc}`;
export const TenantPresentationConfiguration_EffectiveDisclaimerConfigurationFragmentDoc = gql`
    fragment TenantPresentationConfiguration_EffectiveDisclaimerConfiguration on EffectiveDisclaimerConfiguration {
  includeLuminaryDisclaimer
  presentationCoverDisclaimerTitle
  presentationCoverDisclaimerBody
  presentationFooterDisclaimerTitle
  presentationFooterDisclaimerBody
  presentationStandaloneDisclaimerTitle
  presentationStandaloneDisclaimerBody
}
    `;
export const EffectivePresentationDisclaimerConfigurationDocument = gql`
    query EffectivePresentationDisclaimerConfiguration($subBrandID: ID) {
  effectiveDisclaimerConfiguration(subBrandID: $subBrandID) {
    ...TenantPresentationConfiguration_EffectiveDisclaimerConfiguration
  }
}
    ${TenantPresentationConfiguration_EffectiveDisclaimerConfigurationFragmentDoc}`;

/**
 * __useEffectivePresentationDisclaimerConfigurationQuery__
 *
 * To run a query within a React component, call `useEffectivePresentationDisclaimerConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEffectivePresentationDisclaimerConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEffectivePresentationDisclaimerConfigurationQuery({
 *   variables: {
 *      subBrandID: // value for 'subBrandID'
 *   },
 * });
 */
export function useEffectivePresentationDisclaimerConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<EffectivePresentationDisclaimerConfigurationQuery, EffectivePresentationDisclaimerConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EffectivePresentationDisclaimerConfigurationQuery, EffectivePresentationDisclaimerConfigurationQueryVariables>(EffectivePresentationDisclaimerConfigurationDocument, withFetchPolicyContext(options));
      }
export function useEffectivePresentationDisclaimerConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EffectivePresentationDisclaimerConfigurationQuery, EffectivePresentationDisclaimerConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EffectivePresentationDisclaimerConfigurationQuery, EffectivePresentationDisclaimerConfigurationQueryVariables>(EffectivePresentationDisclaimerConfigurationDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useEffectivePresentationDisclaimerConfigurationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EffectivePresentationDisclaimerConfigurationQuery, EffectivePresentationDisclaimerConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EffectivePresentationDisclaimerConfigurationQuery, EffectivePresentationDisclaimerConfigurationQueryVariables>(EffectivePresentationDisclaimerConfigurationDocument, withFetchPolicyContext(options));
        }
export type EffectivePresentationDisclaimerConfigurationQueryHookResult = ReturnType<typeof useEffectivePresentationDisclaimerConfigurationQuery>;
export type EffectivePresentationDisclaimerConfigurationLazyQueryHookResult = ReturnType<typeof useEffectivePresentationDisclaimerConfigurationLazyQuery>;
export type EffectivePresentationDisclaimerConfigurationSuspenseQueryHookResult = ReturnType<typeof useEffectivePresentationDisclaimerConfigurationSuspenseQuery>;
export type EffectivePresentationDisclaimerConfigurationQueryResult = Apollo.QueryResult<EffectivePresentationDisclaimerConfigurationQuery, EffectivePresentationDisclaimerConfigurationQueryVariables>;
export const TenantDisclaimerConfigurationDocument = gql`
    query TenantDisclaimerConfiguration($householdID: ID, $hasHouseholdID: Boolean!) {
  tenantInformation {
    id
    disclosuresConfiguration {
      ...TenantPresentationConfiguration_TenantDisclaimerConfiguration
    }
  }
  households(where: {id: $householdID}) @include(if: $hasHouseholdID) {
    edges {
      node {
        ...TenantPresentationConfiguration_Household
      }
    }
  }
}
    ${TenantPresentationConfiguration_TenantDisclaimerConfigurationFragmentDoc}
${TenantPresentationConfiguration_HouseholdFragmentDoc}`;

/**
 * __useTenantDisclaimerConfigurationQuery__
 *
 * To run a query within a React component, call `useTenantDisclaimerConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantDisclaimerConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantDisclaimerConfigurationQuery({
 *   variables: {
 *      householdID: // value for 'householdID'
 *      hasHouseholdID: // value for 'hasHouseholdID'
 *   },
 * });
 */
export function useTenantDisclaimerConfigurationQuery(baseOptions: Apollo.QueryHookOptions<TenantDisclaimerConfigurationQuery, TenantDisclaimerConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantDisclaimerConfigurationQuery, TenantDisclaimerConfigurationQueryVariables>(TenantDisclaimerConfigurationDocument, withFetchPolicyContext(options));
      }
export function useTenantDisclaimerConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantDisclaimerConfigurationQuery, TenantDisclaimerConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantDisclaimerConfigurationQuery, TenantDisclaimerConfigurationQueryVariables>(TenantDisclaimerConfigurationDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useTenantDisclaimerConfigurationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TenantDisclaimerConfigurationQuery, TenantDisclaimerConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TenantDisclaimerConfigurationQuery, TenantDisclaimerConfigurationQueryVariables>(TenantDisclaimerConfigurationDocument, withFetchPolicyContext(options));
        }
export type TenantDisclaimerConfigurationQueryHookResult = ReturnType<typeof useTenantDisclaimerConfigurationQuery>;
export type TenantDisclaimerConfigurationLazyQueryHookResult = ReturnType<typeof useTenantDisclaimerConfigurationLazyQuery>;
export type TenantDisclaimerConfigurationSuspenseQueryHookResult = ReturnType<typeof useTenantDisclaimerConfigurationSuspenseQuery>;
export type TenantDisclaimerConfigurationQueryResult = Apollo.QueryResult<TenantDisclaimerConfigurationQuery, TenantDisclaimerConfigurationQueryVariables>;